import { React, useEffect, useState } from "react";
import img_caracol from "../../../assets/images/img_caracol.png";
import ico_lombriz from "../../../assets/icons/ico_lombriz.svg";
import VideoGroupsBanner from "../../../components/videoGroupsBanner";
import GroupInfoSection from "../../../components/groupInfoSection";
import GoToPage from "../../../components/goToPage";
import GroupsVideoFooter from "../../../components/groupsVideoFooter";
const SoilInvertebratesScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "https://drive.google.com/uc?export=download&id=1tIJ6tOcvie2j2X2iOU0YxDypFkzvSFX0";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="bg-[#002E0F] h-full">
        {width > 1300 ? (
        <div>
<div className="grid overflow-hidden lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
          <div className="relative w-full lg:h-full">
          <VideoGroupsBanner videoSource={bosque} left="3%" />
          <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
            <GoToPage
              page="/grupos"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <img
          
            src={img_caracol}
            alt=""
            className="w-full bottom-0 absolute z-40 pr-32"
          />
        </div>

        <GroupInfoSection
          webvrurl="https://niv1.vercel.app/"
          icon={ico_lombriz}
          title={<p>Invertebrados de tierra</p>}
          subTitle=""
          textFirstTab={
            <p>
              Este grupo está compuesto por organismos de distintos grupos taxonómicos, como hongos, bacterias y fauna. En el caso de la fauna o animales que habitan el suelo, se pueden clasificar según su tamaño en microfauna (menor a 100 micras), mesofauna (entre 100 micras y 2mm) y macrofauna (entre 2 mm y 20 mm). Estos últimos grupos incluyen animales como nemátodos, ácaros, lombrices, insectos, protozoarios y moluscos, entre otros artrópodos.
            </p>
          }
          textSecondTab={
            <p>
              La biodiversidad del suelo es clave para el funcionamiento de los ecosistemas ya que contribuye con el ciclo de nutrientes, la dinámica y descomposición de la materia orgánica, el secuestro de carbono, el ciclo del agua y los procesos de erosión; todos estos, importantes servicios ecosistémicos de regulación y de soporte claves para la vida en el planeta.

            </p>
          }
          textThirdTab={
            <p>
              Según el objetivo del monitoreo a través de un análisis biológico
              del suelo, las muestras se pueden obtener en zonas agrícolas,
              zonas de amortiguamiento de plantaciones o bosques, por ejemplo,
              para determinar las comunidades edáficas según el uso del suelo,
              con fines comparativos entre parcelas o para determinar la calidad
              microbiológica del suelo.
            </p>
          }
        ></GroupInfoSection>
      </div>
        </div>
        ):(
            <div className="min-h-[100vh] grid grid-cols-1 h-full">
            <div className=" bg-[#002E0F] left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
              <GoToPage
                page="/grupos"
                side="left"
                name="Atrás"
                fontsize="text-lg"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-4"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div style={{"z-index":"1"}}>
            <GroupInfoSection
          webvrurl="https://niv1.vercel.app/"
          icon={ico_lombriz}
          title={<p>Invertebrados de tierra</p>}
          subTitle=""
          textFirstTab={
            <p>
              Este grupo está compuesto por organismos de distintos grupos taxonómicos, como hongos, bacterias y fauna. En el caso de la fauna o animales que habitan el suelo, se pueden clasificar según su tamaño en microfauna (menor a 100 micras), mesofauna (entre 100 micras y 2mm) y macrofauna (entre 2 mm y 20 mm). Estos últimos grupos incluyen animales como nemátodos, ácaros, lombrices, insectos, protozoarios y moluscos, entre otros artrópodos.
            </p>
          }
          textSecondTab={
            <p>
             La biodiversidad del suelo es clave para el funcionamiento de los ecosistemas ya que contribuye con el ciclo de nutrientes, la dinámica y descomposición de la materia orgánica, el secuestro de carbono, el ciclo del agua y los procesos de erosión; todos estos, importantes servicios ecosistémicos de regulación y de soporte claves para la vida en el planeta.

            </p>
          }
          textThirdTab={
            <p>
              Según el objetivo del monitoreo a través de un análisis biológico
              del suelo, las muestras se pueden obtener en zonas agrícolas,
              zonas de amortiguamiento de plantaciones o bosques, por ejemplo,
              para determinar las comunidades edáficas según el uso del suelo,
              con fines comparativos entre parcelas o para determinar la calidad
              microbiológica del suelo.
            </p>
          }
        ></GroupInfoSection>
            </div>
            <div className="relative w-full lg:h-full flex justify-center">
              <GroupsVideoFooter videoSource={bosque} />
             
              <img
              
                src={img_caracol}
                alt=""
                className="lg:w-[48rem] md:w-[38rem] sm:w-[28rem] w-[23rem] h-fit-content bottom-0 -left-24 absolute "
              />
            </div>
          </div>
        )}
      
    </div>
  );
};

export default SoilInvertebratesScreen;
